import { Routes } from '@angular/router';
import { NoAuthGuard } from '../core/auth/no-auth.guard';
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/web/home/home.component';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'home' },
  {
    path: 'auth',
    canActivateChild: [NoAuthGuard],
    canActivate: [NoAuthGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'sign-in' },
      {
        path: 'sign-in',
        loadChildren: () => import('./pages/auth/sign-in/sign-in.routes'),
      },
      {
        path: 'sign-up',
        loadChildren: () => import('./pages/auth/sign-up/sign-up.routes'),
      },
      {
        path: 'forgot-password',
        loadChildren: () =>
          import('./pages/auth/forgot-password/forgot-password.routes'),
      },
    ],
  },
  {
    path: '',
    children: [
      {
        path: 'home',
        loadChildren: () => import('./pages/web/home/home.routes'),
      },
      {
        path: 'worksofart',
        loadChildren: () =>
          import('./pages/web/works-of-art/works-of-art.routes'),
      },
      {
        path: 'events',
        loadChildren: () => import('./pages/web/events/events.routes'),
      },
      {
        path: 'event/:id',
        loadChildren: () => import('./pages/web/event/event.routes'),
      },
      {
        path: 'contact',
        loadChildren: () => import('./pages/web/contact/contact.routes'),
      },
      {
        path: 'artists',
        loadChildren: () => import('./pages/web/artists/artists.routes'),
      },
      {
        path: 'artist/:id',
        loadChildren: () => import('./pages/web/artist/artist.routes'),
      },

      {
        path: 'maintenance',
        loadChildren: () =>
          import('./pages/web/maintenance/maintenance.routes'),
      },
      {
        path: 'postulation',
        loadChildren: () =>
          import('./pages/web/postulation/postulation.routes'),
      },
      {
        path: 'favorites',
        loadChildren: () => import('./pages/web/favorites/favorites.routes'),
      },
      {
        path: 'about',
        loadChildren: () => import('./pages/web/about/about.routes'),
      },
      {
        path: 'partners',
        loadChildren: () => import('./pages/web/partners/partners.routes'),
      },
      {
        // Destino del QR de descarga (ABC-399). La ruta se imprime en material
        // gráfico: es estable y no se renombra.
        path: 'app',
        loadChildren: () =>
          import('./pages/web/download-app/download-app.routes'),
      },
      {
        path: 'support',
        loadChildren: () => import('./pages/web/support/support.routes'),
      },
      {
        path: 'timer',
        loadChildren: () => import('./pages/web/timer/timer.routes'),
      },
    ],
  },
];
